<template>
  <div class="relative bg-white m-3 rounded-md">
    <div class="border-b-0.5 flex justify-between items-center p-3">
      <p class="text-sm font-semibold">Email Tempates</p>
      <button
        @click="showCreateEmailTemplate = true"
        class="bg-primary text-white px-3 text-sm py-1 rounded-md"
      >
        Create templates
      </button>
    </div>
    <transition name="fade">
      <div
        v-if="showEmailCreateSuccess"
        class="p-1 text-center text-sm w-full bg-green-200"
      >
        {{ create_success }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="showEmailSaveError"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ saveError }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="get_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ get_error }}
      </div>
    </transition>
    <div v-if="loading" class="absolute inset-0 bg-white z-50 rounded-md">
      <loader class="absolute inset-x-0 top-20" />
    </div>
    <div v-if="innerLoader" class="absolute inset-0 bg-white z-50 rounded-md">
      <loader class="absolute inset-x-0 inset-y-10" />
    </div>
    <div
      v-if="loadingTemplates"
      class="absolute inset-0 bg-white z-50 rounded-md"
    >
      <loader class="absolute center-h-v" />
    </div>
    <div>
      <div class="flex flex-wrap gap-x-3 justify-between bg-gray-100">
        <div class="text-sm flex gap-5 items-center">
          <p class="p-3">Choose template to edit</p>

          <select
            ref="printerSelect"
            v-model="selectedTemplateId"
            @change="onChange()"
            class="text-sm bg-transparent border-1.5 p-2 mr-3 rounded-md"
          >
            <option
              :value="template.Id"
              v-for="(template, index) in emailTemplatesList"
              :key="index"
            >
              {{ template.TemplateName }}
            </option>
          </select>
        </div>

        <div
          v-if="selectedTemplate != null"
          class="flex justify-end my-4 ml-3 pr-3"
        >
          <button
            @click="deleteTemplate(selectedTemplate[0].Id)"
            class="border border-0.5 border-red-500 text-red-500 px-3 text-sm py-1 rounded-md my-1"
          >
            Delete this templates
          </button>
        </div>
      </div>
      <p v-if="selectedTemplate == null" class="p-3 text-center">
        No template selected
      </p>
      <div
        v-if="selectedTemplate != null"
        class="grid lg:grid-cols-2 grid-cols-1"
      >
        <div class="p-5">
          <p class="pb-2 text-sm">Email template preview</p>
          <iframe
            v-if="selectedTemplate != null"
            class="w-full min-h-screen"
            :srcdoc="selectedTemplate[0].TemplateBody"
          ></iframe>
        </div>
        <div class="p-5">
          <div class="flex justify-end">
            <button
              @click="saveChanges"
              class="bg-green-400 text-white px-3 text-sm py-1 rounded-md my-1"
            >
              Save Changes
            </button>
          </div>
          <MonacoEditor
            v-if="selectedTemplate != null"
            language="html"
            :options="options"
            class="editor w-full h-full"
            v-model="selectedTemplate[0].TemplateBody"
          />
        </div>
      </div>
    </div>
    <CreateEmailTemplate
      :showCreateEmailTemplate="showCreateEmailTemplate"
      @close="close"
      @closeOnSuccess="handleCloseOnSuccess"
    ></CreateEmailTemplate>
  </div>
</template>

<script>
import axios from "axios";
var _ = require("lodash");
const prettify = require("html-prettify");
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
import CreateEmailTemplate from "@/components/AdminSetups/email/createEmailTemplate.vue";
import MonacoEditor from "vue-monaco";
export default {
  name: "EmailTemplate",
  props: [
    "emailTemplatesList",
    "loading",
    "loadingTemplates",
    "emailVariables",
  ],
  components: { Loader, MonacoEditor, CreateEmailTemplate },
  data() {
    return {
      templateText: "",
      textCopied: false,
      templateId: null,
      showCreateEmailTemplate: false,
      showEmailCreateSuccess: false,
      create_success: null,
      showEmailSaveError: null,
      saveError: null,
      get_error: null,
      innerLoader: false,
      selectedTemplate: null,
      selectedTemplateId: null,
      options: {
        autoIndent: "full",
        lineNumbers: true,
        formatOnType: true,
        formatOnPaste: true,
      },
    };
  },
  watch: {
    loadingTemplates(loading) {
      if (!loading) {
        this.selectedTemplate = this.emailTemplatesList[0];
      }
    },
  },
  computed: {
    ...mapGetters(["getToken"]),
    indentedTemplate() {
      var indented = prettify(this.selectedTemplate[0].TemplateBody);
      return indented;
    },
  },

  methods: {
    onChange() {
      this.selectedTemplate = _.filter(this.emailTemplatesList, [
        "Id",
        this.selectedTemplateId,
      ]);
    },
    close() {
      this.showCreateEmailTemplate = false;
    },
    saveChanges() {
      this.innerLoader = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      var data = {
        TemplateId: this.selectedTemplate[0].Id,
        TemplateName: this.selectedTemplate[0].TemplateName,
        TemplateBody: this.selectedTemplate[0].TemplateBody,
      };
      axios
        .put(
          `setup/email/template/${this.$ApiVersion}/edit`,
          JSON.stringify(data),
          options
        )
        .then(
          (response) => {
            this.innerLoader = false;
            if (response.data.StatusCode == 200) {
              //this.$emit("closeOnSuccess", response.data.StatusMessage);

              this.handleCloseOnSuccess(response.data.StatusMessage);
            } else {
              this.handleErrorOnSaveChanges(response.data.StatusMessage);
            }
          },
          (error) => {
            this.innerLoader = false;
            this.handleErrorOnSaveChanges(error.message);
          }
        );
    },
    deleteTemplate(id) {
      this.innerLoader = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .delete(
          `setup/email/template/${id}/${this.$ApiVersion}/delete`,
          options
        )
        .then(
          (response) => {
            this.innerLoader = false;
            if (response.data.StatusCode == 200) {
              this.handleCloseOnSuccess(response.data.StatusMessage);
              this.selectedTemplate = null;
            } else {
              this.handleErrorOnSaveChanges(response.data.StatusMessage);
            }
          },
          (error) => {
            this.innerLoader = false;
            this.handleErrorOnSaveChanges(error.message);
          }
        );
    },
    handleErrorOnSaveChanges(message) {
      this.saveError = message;
      this.showEmailSaveError = true;
      setTimeout(() => {
        this.showEmailSaveError = false;
      }, 3000);
    },
    handleCloseOnSuccess(message) {
      this.create_success = message;
      this.showCreateEmailTemplate = false;
      this.showEmailCreateSuccess = true;
      setTimeout(() => {
        this.showEmailCreateSuccess = false;
      }, 3000);
      this.$emit("updateEmailTemplatesList");
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
